module.exports = __webpack_public_path__ + "static/media/7-8.0229a8ba.mp3";